import React, { useEffect, useState } from "react";
import { itemsPerPage } from "../../utils/constants";
import DataTable from "../../common/dataTable";
import TablePagination from "../../common/tablePagination";
import { Box, Radio } from "@mui/material";
import Searchbar from "../../common/searchbar";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions";
import CreateMasterModal from "./modals/createMasterModal";
import { useForm } from "react-hook-form";
import EditMasterModal from "./modals/editMasterModal";
import commonActions from "../../redux/common/actions";
import { PiPlusBold } from "react-icons/pi";
import masterActions from "../../redux/master/actions";

const tableKeys = [
  {
    name: "SI.NO",
    accessor: "id",
    sortOption: false,
  },
  {
    name: "Graduation Branch",
    accessor: "graduationbranch",
    sortOption: false,
  },
  {
    name: "G Specialization Subject",
    accessor: "gspecializaiton",
    sortOption: false,
  },
  {
    name: "Enable",
    accessor: "enable",
    sortOption: false,
  },
  {
    name: "Disable",
    accessor: "disable",
    sortOption: false,
  },
];

export default function GspecializationSubjectMaster() {
  const dispatch = useDispatch();

  const { gspecializationSubjectList, graduationBranchList } = useSelector(
    (state) => state.masterFormsReducer
  );

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    getValues,
    trigger,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_GRADUATION_BRANCH });
    dispatch({ type: masterFormsActions.GET_GSPECIALIZATION_SUBJECT });
    //eslint-disable-next-line
  }, []);

  const handleActive = (active, type, gspecializationid) => {
    if (type !== active) {
      let data = {
        userid: backofficeTokenDetails?.id,
        id: gspecializationid,
        idname: "gspecializationid",
        status: type,
        action: masterFormsActions.GET_GSPECIALIZATION_SUBJECT,
      };

      dispatch({
        type: masterActions.SET_MASTERS_STATUS,
        payload: data,
      });
    }
  };

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = gspecializationSubjectList?.filtered
    ?.map((obj) => {
      let string = "";
      for (let i = 0; i <= obj?.graduationbranchid.length - 1; i++) {
        string += `${
          graduationBranchList?.all?.find(
            (param) => param.graduationbranchid === obj.graduationbranchid[i]
          )?.graduationbranch
        }${i + 1 < obj?.graduationbranchid.length ? "," : ""}`;
      }

      return {
        ...obj,
        graduationbranch: string,
        enable: (
          <Radio
            checked={obj.status === "1"}
            onClick={() => handleActive(obj.status, "1", obj.gspecializationid)}
          />
        ),
        disable: (
          <Radio
            checked={obj.status === "0"}
            onClick={() => handleActive(obj.status, "0", obj.gspecializationid)}
          />
        ),
      };
    })
    ?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(
    gspecializationSubjectList?.filtered?.length / itemsPerPage
  );

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  const handleCreate = (data) => {
    data["graduationbranchid"] = data.graduationbranchid.map((id) =>
      parseInt(id)
    );
    data["gspecializaiton"] = data.name;

    data["userid"] = backofficeTokenDetails?.id;

    dispatch({
      type: masterFormsActions.CREATE_GSPECIALIZATION_SUBJECT,
      payload: { data: data, resetForm: resetForm },
    });
  };

  const resetForm = () => {
    reset({
      name: "",
      graduationbranchid: [],
    });
  };

  const handleSearch = (e) => {
    let filtered = [];
    setCurrentPage(1);
    setItemOffset(0);
    if (e.target.value) {
      //eslint-disable-next-line
      filtered = gspecializationSubjectList?.all?.filter((val) => {
        if (
          val?.gspecializaiton
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase()) ||
          val?.graduationbranch
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase())
        ) {
          return val;
        }
      });
    } else {
      filtered = [...gspecializationSubjectList?.all];
    }
    dispatch({
      type: masterFormsActions.SET_GSPECIALIZATION_SUBJECT,
      payload: { ...gspecializationSubjectList, filtered: filtered },
    });
  };

  const handleMasteredit = (page, value) => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: page, method: "U", data: null },
    });
    reset({
      name: value?.gspecializaiton,
      graduationbranchid: value?.graduationbranchid,
      userid: value?.userid,
      gspecializationid: value?.gspecializationid,
    });
  };

  const handleUpdate = (data) => {
    data["graduationbranchid"] = data.graduationbranchid.map((id) =>
      parseInt(id)
    );

    data["gspecializaiton"] = data.name;

    data["userid"] = backofficeTokenDetails?.id;
    dispatch({
      type: masterFormsActions.UPDATE_GSPECIALIZATION_SUBJECT,
      payload: {
        id: data?.gspecializationid,
        data: data,
        resetForm: resetForm,
      },
    });
  };

  const handleshowModal = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: true,
        type: "gspecializationsubject",
        method: "C",
        data: null,
      },
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "24px",
          marginBottom: "14px",
        }}
      >
        {/* <Box></Box> */}
        <Searchbar height={48} handleSearch={handleSearch} />
        <MauvelousPrimaryButton
          title={"Add"}
          icon={<PiPlusBold />}
          handleClick={handleshowModal}
        />
      </Box>
      <Box sx={{ height: "calc(100vh - 280px)" }}>
        <DataTable
          keys={tableKeys}
          values={currentItems}
          page={"gspecializationsubject"}
          handleMasteredit={handleMasteredit}
        />
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: "24px",
          padding: "15px 0",
          width: "100%",
          py: 1,
        }}
      >
        <TablePagination
          pageCount={pageCount}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      </Box>

      <CreateMasterModal
        register={register}
        handleSubmit={handleSubmit}
        getValues={getValues}
        trigger={trigger}
        errors={errors}
        handleCreate={handleCreate}
        resetForm={resetForm}
        control={control}
      />
      <EditMasterModal
        register={register}
        handleSubmit={handleSubmit}
        getValues={getValues}
        trigger={trigger}
        errors={errors}
        handleUpdate={handleUpdate}
        resetForm={resetForm}
        control={control}
      />
    </>
  );
}
